import { IDoctor } from 'app/shared/model/doctor.model';
import { InvestigationType } from 'app/shared/model/enumerations/investigation-type.model';

export interface IDoctorRegularInvestigation {
  id?: string;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  createdDtm?: number | null;
  createdBy?: string | null;
  investigationType?: keyof typeof InvestigationType | null;
  investigationId?: string | null;
  doctor?: IDoctor | null;
}

export const defaultValue: Readonly<IDoctorRegularInvestigation> = {
  active: false,
};
